module.exports = __webpack_public_path__ + "img/logo-ipssoma.f07af647.png";